import type {
  IAPIErrorDataBase,
  TAPIErrorData,
  TAPIErrorKind,
} from '~/api/client/APIError/types'
import type {TGenericizedPathWithHTTPVerb} from '~/api/client/types'

/** Superclass for all API error responses. Subclasses contain extra data / helper methods. */
export default abstract class APIError implements IAPIErrorDataBase {
  public readonly errorData: TAPIErrorData
  public readonly kind: TAPIErrorKind
  public readonly statusCode: number
  public readonly statusText: string
  public readonly rawResponseData: unknown
  public readonly genericizedPathWithHTTPVerb:
    | TGenericizedPathWithHTTPVerb
    | undefined

  constructor(errorData: TAPIErrorData) {
    const {
      kind,
      statusCode,
      statusText,
      rawResponseData,
      genericizedPathWithHTTPVerb,
    } = errorData
    this.errorData = errorData
    this.kind = kind
    this.statusCode = statusCode
    this.statusText = statusText
    this.rawResponseData = rawResponseData
    this.genericizedPathWithHTTPVerb = genericizedPathWithHTTPVerb
  }

  /** All subclasses should be able to produce a (hopefully concise) error message for displaying to the user. */
  public abstract toHumanString(): string
}
